// extracted by mini-css-extract-plugin
export default {"change_password":"change_password_change_password__yUC+1","buttons":"change_password_buttons__8u3aS","textfield_label":"change_password_textfield_label__Ga5nZ"};